/**

{
  title: ``,
  description: ``,
  details: [``],
},

 */

export const changelogData = [
  {
    releaseDate: "11-24-2025", // CURRENT
    summary:
      "Salesforce Synce, Loan Drilldown, Loan Pipeline, and Pipeline Fixes",
    changes: {
      features: [
        {
          title: `Loan drilldown > General`,
          description: `General improvements to the drilldown experience, including Salesforce sync support and easier navigation between loans.`,
          details: [
            `Added ability to sync loans with Salesforce. This can by done by clicking "Salesforce Integration" > "Status Sync". This requires you to first enter an external loan sync ID.`,
            `Added Quick Search ability to search other loans while on a loan drilldown (Search icon in the top left of the loan)`,
            `Added ability to pin loans in the loan drilldown header`,
            `Added display showing repeat borrowers in the Summary card`,
          ],
        },
        {
          title: `Loan drilldown > Loan Information`,
          description: `Loan meta additions.`,
          details: [
            `Added "Term Months" field in the loan drilldown under the "Loan Information" tab (loan meta section)`,
          ],
        },
        {
          title: `Loan drilldown > Borrowers tab`,
          description: `Borrower metadata and table cleanup.`,
          details: [
            `Added "Is Repeat Borrower" field`,
            `Removed "First Time Homebuyer" from table`,
          ],
        },
        {
          title: `Loan drilldown > Files Tab`,
          description: `Files table improvements and status standardization.`,
          details: [
            // `Improved the "Expiring Documents" section to automatically display expiration date based on pre-specified document types (e.g., Loan Applications valid for 180 days)`,
            `Added the ability to group files by "Document Type" and "Category and Type"`,
            `Updated document status options in the Files Table to: New Upload, Pending Review, Incomplete, Rejected, Accepted`,
          ],
        },
        {
          title: `Loan drilldown > Fees Tab`,
          description: `New fees workflow and related actions.`,
          details: [
            `Added Fees table with ability to add and edit fees`,
            `Added ability to set Title Contact`,
            `Added ability to set Entity`,
            `Added ability to edit and download funding shield`,
          ],
        },

        {
          title: `Loan Pipeline`,
          description: `Pipeline usability and layout improvements.`,
          details: [
            `Added ability to pin multiple loans in the loan pipeline by clicking the Loan Tab Navigator Button`,
            `When "Show Loans Assigned to Me" is selected, loans will now display when you are a listed user in the "Permitted Users" list.`,
          ],
        },
      ],
      bugFixes: [
        {
          title: `Loan drilldown > Loan Closing`,
          description: `Fixed Loan Closing from not appearing when clicking on a tab.`,
        },
      ],
    },
  },

  {
    releaseDate: "11-17-2025", // CURRENT
    summary: "Loan Closing Status, Document Groups, and Pipeline Fixes",
    changes: {
      features: [
        {
          title: `Closing Status field in Loan Drilldown`,
          description: `Added a "Closing Status" field to the loan drilldown. This can be found in the "Loan Information" tab under "Loan Closing".`,
        },
        {
          title: `Added "External Sync Loan ID" in the Loan Pipeline Table`,
          description: `This field is hidden by default, but can accessed by editing table columns on the right side of the table.`,
        },
        {
          title: `New document types in "Terms & Sizer" group`,
          description: `Added the following document types to the "Terms & Sizer" document group:`,
          details: [`Net Wire Calculator`],
        },
        {
          title: `New document types in "Title Docs" group`,
          description: `Added the following document types to the "Title Docs" document group:`,
          details: [
            "Funding Shield Request",
            "Funding Shield Verification - Wire Instructions",
          ],
        },
      ],
      bugFixes: [
        {
          title: `Fixed naming issue in Loan Status cell`,
          description: `Previously, incorrect names would occasionally be displayed in the "Updated By" and "Updated Date" fields in the Loan Status cell of the Loan Files table.`,
        },
        {
          title: `Fixed loan pipeline counts when "Only My Loans" is selected`,
          description: `Previously, the counts for the number of loans in each pipeline did not update correctly when the "Only My Loans" filter was applied.`,
        },
        {
          title: `Fixed "Purchase Price" field on the Loan Application Form`,
          description: `Previously, the "Purchase Price" field was showing a date field instead of a dollar field.`,
        },
      ],
    },
  },
  {
    releaseDate: "11-14-2025",
    summary: "Enhanced Loan Drilldown Features & Audit Capabilities",
    changes: {
      features: [
        {
          title: "External Sync ID Configuration",
          description:
            "Added support for setting an external sync ID in the loan drilldown, accessible via the Loan Information tab under 'Loan Meta'.",
        },
        {
          title: "Comprehensive Audit Trail",
          description:
            "Introduced a historical changelog system accessible through the right toolbar in the loan drilldown. Track detailed change history across multiple loan components.",
          details: [
            "Loan document status change history with timestamps and user attribution",
            "Complete audit trail for all loan document modifications",
            "Full tracking of checklist item additions, removals, and updates",
          ],
          note: "Change tracking begins with this release - historical data prior to 2025-11-14 is not available.",
        },
        {
          title: "Enhanced Files Table Metadata",
          description:
            "Expanded the File Status cell to display 'Updated By' and 'Updated Date' information for improved file tracking and accountability.",
        },
      ],
    },
  },
  {
    releaseDate: "11-13-2025",
    summary: "Loan Drilldown Updates and File Management Improvements",
    changes: {
      features: [
        {
          title: "Loan Drilldown Files Table",
          description:
            "The following updates relate to the table found on the Files tab in the Loan Drilldown.",
          details: [
            ` Added "Freeze Panes" button that pins the file name for easier horizontal navigation.`,
            `Added "Legal Reviewed" as a new status option.`,
            "Updated color coding - only status cells change color instead of entire rows. Color scheme: Yellow for Initial/Legal Reviewed, Red for Expired/Rejected, Green for Accepted.",
          ],
        },
        {
          title: "Loan Drilldown Related Contacts",
          description:
            "Contact information can now be updated directly from the Related Contacts table by clicking any row in the table.",
        },
      ],
      // features: [
      //   {
      //     title: "Loan Sync ID Display",
      //     description:
      //       "Added loan sync ID visibility in the loan drilldown header.",
      //     details: [
      //       "Sync ID now appears next to the Loan # in the header.",
      //       "Field is automatically hidden when no sync ID exists.",
      //     ],
      //   },
      //   {
      //     title: "Related Contacts Inline Editing",
      //     description:
      //       "Contact information can now be updated directly from the Related Contacts section.",
      //     details: [
      //       "Click on any table row to edit contact data.",
      //       "Updates are sent with only the modified values in the payload.",
      //     ],
      //   },
      //   {
      //     title: "Files Freeze Panes",
      //     description:
      //       "Added ability to pin key columns in the Files table for easier navigation.",
      //     details: [
      //       "New 'Freeze Panes' button pins file name, actions, and status columns to the left.",
      //       "Improves usability when scrolling through files with many columns.",
      //     ],
      //   },
      // ],
      // improvements: [
      //   {
      //     title: "Loan Files Visual Updates",
      //     description: "Refined the visual presentation of file statuses:",
      //     details: [
      //       "Added 'Legal Reviewed' as a new status option.",
      //       "Updated color coding - only status cells change color instead of entire rows.",
      //       "Color scheme: Yellow for Initial/Legal Reviewed, Red for Expired/Rejected, Green for Accepted.",
      //     ],
      //   },
      //   {
      //     title: "Sizers Integration",
      //     description: "Added new endpoint for retrieving sizers data:",
      //     details: [
      //       "New 'get sizers by deal ID' endpoint added to Sizers tab.",
      //       "Currently returns 200 status with 'No sizer uploads found' message.",
      //     ],
      //   },
      // ],
    },
  },
  {
    releaseDate: "10-21-2025",
    summary: "Loan Checklist, Files, and General Loan Improvements",
    changes: {
      features: [
        {
          title: "Borrower & Property Associations",
          description:
            "Borrowers and properties can now be associated (tagged) with other parts of the loan, such as files.",
          details: [
            "Associations can be managed by clicking on an individual borrower or property in their respective tabs.",
            "This functionality will continue to expand with future enhancements.",
          ],
        },
      ],
      improvements: [
        {
          title: "Loan Checklist",
          description: "General improvements to the Loan Checklist:",
          details: [
            "Styled the `Not Applicable` status in green and made it functionally equivalent to `Completed`.",
            "Enabled file previews while keeping the checklist visible in the right sidebar (when not pinned). Previously, opening a file would replace the checklist view.",
            "Reduced visual clutter by hiding additional item details by default.",
          ],
        },
        {
          title: "Loan Files",
          description:
            "General improvements to the Loan Files section in the loan drilldown:",
          details: [
            "Added tooltips indicating left-click to preview and right-click for more options. This applies specifically to the primary Loan Files table in the Files tab.",
            "Grouped files by document type for easier navigation. This applies to isolated document tables found in the Entity, Borrower, and Property tabs.",
          ],
        },
      ],
      bugFixes: [
        {
          title: "Loan Checklist",
          description:
            "Resolved several issues affecting checklist interactions:",
          details: [
            "Fixed an issue where comments were not displaying correctly after submitting one on a checklist item.",
            "Fixed an issue where saved changes were not displaying correctly after navigating away from and returning to the checklist tab.",
          ],
        },
      ],
      investigating: [
        {
          title: "Loan Checklist",
          description: "Items currently under investigation:",
          details: [
            "Adding Yes/No options to checklist items — pending backend data structure updates before implementation.",
            "Investigating performance issues with checklist rendering — awaiting additional team feedback on the final layout before optimization.",
          ],
        },
      ],
    },
  },
];

// Helper functions to work with changelog data
export const getLatestVersion = () => {
  return changelogData[0]?.version || "";
};

export const getVersionByNumber = (versionNumber) => {
  return changelogData.find((release) => release.version === versionNumber);
};

export const getFeatureCount = (version) => {
  const release = changelogData.find((r) => r.version === version);
  return release?.changes.features.length || 0;
};

export const getAllVersions = () => {
  return changelogData.map((release) => ({
    version: release.version,
    date: release.releaseDate,
    type: release.releaseType,
  }));
};

export const hasBreakingChanges = (version) => {
  const release = changelogData.find((r) => r.version === version);
  return release?.changes.breakingChanges.length > 0;
};

// Get changes between two versions
export const getChangesSince = (version) => {
  const versionIndex = changelogData.findIndex((r) => r.version === version);
  if (versionIndex === -1) return changelogData;
  return changelogData.slice(0, versionIndex);
};

// Search functionality
export const searchChangelog = (searchTerm) => {
  const term = searchTerm.toLowerCase();
  return changelogData.filter((release) => {
    const searchIn = JSON.stringify(release).toLowerCase();
    return searchIn.includes(term);
  });
};
